import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent implements OnInit, OnDestroy {

  currentUser: any;
  notifications = [];
  notificationsToShow = [];
  name: string;
  subscription: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.findAllNotifications();
    this.connect();


  }

  findAllNotifications() {

  }

  connect() {

  }

  disconnect() {

  }

  handleMessage(message: any) {
    this.findAllNotifications();
  }

  showNotifications() {
    this.router.navigate(['/account/notifications']);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.disconnect();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  seenBy(id: number) {

  }

  markAllAsSeen() {

  }

  navigateTo(link) {
    if (link) {
      this.router.navigate([link]);
    }
  }

  onNotificationClick(notification: any) {
    this.seenBy(notification.id);
    if (notification.link) {
      this.navigateTo(notification.link);
    }
  }


}
